/* jp-motion — Kinzoku signature motion (R6): brush · ink-draw · kanji-settle · hanko · edge-glint.
   -------------------------------------------------------------------------------------------------
   SUPPLEMENTS Dawn's scroll-trigger reveal (which stays the general card/list reveal via
   settings.animations_reveal_on_scroll). This observer touches ONLY [data-kz] elements, which are
   DISJOINT from .scroll-trigger — no element is ever double-observed (HANDOFF §5 "no second IO" on
   reveals is honoured: two observers, zero overlap).
   Gating: html.kz-motion is added by a tiny head script ONLY when settings.enable_motion is on; the
   CSS initial hidden states additionally sit inside @media (prefers-reduced-motion: no-preference).
   So: no-JS → no head script → no kz-motion → full static content; reduced-motion → hidden states never
   apply. The head script also removes kz-motion after 2s if this file never initialised (load-failure
   safety), so content can never get stuck hidden.
   Perf: transform / opacity / mask-position only (compositor); elements keep their box → CLS 0.
   Never put [data-kz] on the hero H1 or first hero/PDP media that is the LCP element. */
(() => {
  if (window.__jpMotionInit) return;
  window.__jpMotionInit = true;
  const root = document.documentElement;
  if (!root.classList.contains('kz-motion')) return; /* motion disabled (setting off) — nothing to do */
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    /* reduced-motion: reveal everything immediately, no animation (CSS @media also guards the hidden state) */
    root.classList.remove('kz-motion');
    return;
  }
  if (!('IntersectionObserver' in window)) { root.classList.remove('kz-motion'); return; }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('kz-in'); io.unobserve(e.target); }
    });
    /* threshold 0 (any pixel) matches Dawn's animations.js — a firmer ratio would trap an element taller
       than ~3.3× the viewport at opacity:0 forever; rootMargin gives the "just before on-screen" feel. */
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

  /* stagger children of a [data-kz-group] via --kz-delay (cap 5 so a big grid never takes ~1s to settle) */
  const observe = (scope) => {
    /* Customiser: reveal statically (like Dawn's design-mode branch) so an edited section is never stuck hidden */
    const designMode = window.Shopify && window.Shopify.designMode;
    (scope || document).querySelectorAll('[data-kz]:not(.kz-in)').forEach((el) => {
      if (designMode) { el.classList.add('kz-in'); return; }
      const group = el.closest('[data-kz-group]');
      if (group) {
        const kids = Array.prototype.slice.call(group.querySelectorAll('[data-kz]'));
        const i = kids.indexOf(el);
        if (i > 0) el.style.setProperty('--kz-delay', (Math.min(i, 5) * 60) + 'ms');
      }
      io.observe(el);
    });
  };

  observe(document);
  /* Customiser: re-scan a re-rendered section (idempotent — :not(.kz-in) skips already-revealed nodes) */
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();
